const ITEMS = [
  "FBB / SBS",
  "C2S Coated",
  "Recycled Grey Back",
  "Recycled White Back",
  "Quick Sheet Cutting",
  "Pan-India Supply",
];

export const EditorialMarquee = () => {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="editorial-marquee"
      className="bg-muted border-y border-border py-8 overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display italic text-4xl md:text-6xl px-10 text-foreground">{item}</span>
            <span className="text-primary text-3xl md:text-5xl">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
};
